import { gsap } from "gsap";

/* --------------------------------------------------------------------------
   Creates (once) the overlay used for page transitions
-------------------------------------------------------------------------- */
function createTransitionOverlay() {
  let overlay = document.getElementById("page-transition-overlay");

  if (!overlay) {
    overlay = document.createElement("div");
    overlay.id = "page-transition-overlay";
    overlay.style.cssText = `
      position: fixed;
      inset: 0;
      width: 100%;
      height: 100%;
      background: #ffffff;
      z-index: 999999;
      pointer-events: none;
      opacity: 0;
      display: none;
      will-change: opacity;
    `;
    document.body.appendChild(overlay);
  }

  return overlay;
}

/* --------------------------------------------------------------------------
   Init Page Transitions
-------------------------------------------------------------------------- */
function initPageTransition() {
  let overlay = null;

  const isTransitioning = sessionStorage.getItem("page-transitioning") === "true";

  /* -----------------------------------------------
     ARRIVAL ON PAGE — fade in WITHOUT overlay
  ----------------------------------------------- */
  if (isTransitioning) {
    sessionStorage.removeItem("page-transitioning");

    // Fade in the body instead of showing the overlay
    gsap.fromTo(
      document.body,
      { opacity: 0 },
      {
        opacity: 1,
        duration: 0.4,
        ease: "power2.out",
      }
    );
  }

  /* -----------------------------------------------
     LINK INTERCEPTION
  ----------------------------------------------- */
  document.addEventListener("click", (e) => {
    const link = e.target.closest("a");
    if (!link) return;

    const href = link.getAttribute("href");
    if (!href) return;

    // Ignore special links
    if (
      href.startsWith("#") ||
      href.startsWith("mailto:") ||
      href.startsWith("tel:") ||
      href.startsWith("javascript:") ||
      link.hasAttribute("target") ||
      link.hasAttribute("download") ||
      link.hasAttribute("data-fslightbox") ||
      link.classList.contains("no-transition")
    ) {
      return;
    }

    // Internal links only
    let url;
    try {
      url = new URL(href, window.location.origin);
      if (url.origin !== window.location.origin) return;
    } catch {
      return;
    }

    // Now we can safely fade out
    e.preventDefault();

    // Create overlay only on demand
    if (!overlay) overlay = createTransitionOverlay();

    sessionStorage.setItem("page-transitioning", "true");

    overlay.style.display = "block";
    overlay.style.pointerEvents = "auto";

    gsap.to(overlay, {
      opacity: 1,
      duration: 0.35,
      ease: "power2.in",
      onComplete: () => {
        window.location.href = href;
      },
    });
  });
}

/* --------------------------------------------------------------------------
   DOM Ready
-------------------------------------------------------------------------- */
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initPageTransition);
} else {
  initPageTransition();
}
